import StaticCrumb from '../components/StaticCrumb';
import OrganizationsCrumb from '../components/OrganizationsCrumb';
import OrganizationDetailCrumb from '../components/OrganizationDetailCrumb';
import LiveOrganizationServiceInstanceCrumb from '../components/LiveOrganizationServiceInstanceCrumb';
import PlatformCostsCrumb from '../components/PlatformCostsCrumb';
import PlatformCostProviderCrumb from '../components/PlatformCostProviderCrumb';
import PlaybookCrumb from '../components/PlaybookCrumb';
import PlaybookStepCrumb from '../components/PlaybookStepCrumb';
import ServiceCrumb from '../components/ServiceCrumb';
import ServicesCrumb from '../components/ServicesCrumb';
import SkillCrumb from '../components/SkillCrumb';
import SkillFileCrumb from '../components/SkillFileCrumb';
import { BreadcrumbRouteConfig } from '../types';

export const adminRoutes: BreadcrumbRouteConfig = {
    path: '/admin',
    breadcrumbs: [
        {
            component: StaticCrumb,
            props: { label: 'Admin', href: '/admin/dashboard' },
        },
    ],
    children: [
        {
            path: 'dashboard',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'Dashboard', isCurrentPage: true },
                },
            ],
            children: [
                { path: 'summary', breadcrumbs: [] },
                { path: 'growth', breadcrumbs: [] },
                { path: 'unit-economics', breadcrumbs: [] },
                { path: 'retention', breadcrumbs: [] },
                { path: 'engagement', breadcrumbs: [] },
                { path: 'organizations', breadcrumbs: [] },
            ],
        },
        {
            path: 'workflow-ops',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'Workflow Ops', isCurrentPage: true },
                },
            ],
        },
        {
            path: 'playbooks',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'Playbooks', href: '/admin/playbooks' },
                },
            ],
            children: [
                {
                    path: ':playbookId/builder',
                    breadcrumbs: [
                        {
                            component: PlaybookCrumb,
                            props: { param: 'playbookId' },
                        },
                        {
                            component: StaticCrumb,
                            props: { label: 'Builder', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':playbookId/versions/:versionId/builder',
                    breadcrumbs: [
                        {
                            component: PlaybookCrumb,
                            props: { param: 'playbookId' },
                        },
                        {
                            component: StaticCrumb,
                            props: { label: 'Builder', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':playbookId/versions/:versionId/document',
                    breadcrumbs: [
                        {
                            component: PlaybookCrumb,
                            props: { param: 'playbookId' },
                        },
                        {
                            component: StaticCrumb,
                            props: { label: 'Document', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':playbookId/versions/:versionId/slides',
                    breadcrumbs: [
                        {
                            component: PlaybookCrumb,
                            props: { param: 'playbookId' },
                        },
                        {
                            component: StaticCrumb,
                            props: { label: 'Slides', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':playbookId/versions/:versionId/builder/steps/:stepId',
                    breadcrumbs: [
                        {
                            component: PlaybookCrumb,
                            props: { param: 'playbookId' },
                        },
                        {
                            component: PlaybookStepCrumb,
                            props: { param: 'stepId', isCurrentPage: true },
                        },
                    ],
                },
            ],
        },
        {
            path: 'services',
            breadcrumbs: [
                {
                    component: ServicesCrumb,
                },
            ],
            children: [
                {
                    path: ':serviceId',
                    breadcrumbs: [
                        {
                            component: ServiceCrumb,
                            props: { param: 'serviceId', isCurrentPage: true },
                        },
                    ],
                    children: [
                        { path: 'billing', breadcrumbs: [] },
                        { path: 'playbooks', breadcrumbs: [] },
                    ],
                },
            ],
        },
        {
            path: 'team',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: { label: 'Team', isCurrentPage: true },
                },
            ],
        },
        {
            path: 'organizations',
            breadcrumbs: [
                {
                    component: OrganizationsCrumb,
                },
            ],
            children: [
                {
                    path: ':organizationId',
                    breadcrumbs: [
                        {
                            component: OrganizationDetailCrumb,
                            props: { param: 'organizationId', isCurrentPage: true },
                        },
                    ],
                    children: [
                        {
                            path: 'services',
                            breadcrumbs: [],
                            children: [
                                {
                                    path: ':instanceId',
                                    breadcrumbs: [
                                        {
                                            component: StaticCrumb,
                                            props: {
                                                label: 'Services',
                                                href: '/admin/organizations/:organizationId/services',
                                            },
                                        },
                                        {
                                            component: LiveOrganizationServiceInstanceCrumb,
                                            props: {
                                                param: 'instanceId',
                                                isCurrentPage: true,
                                            },
                                        },
                                    ],
                                    children: [
                                        { path: 'billing', breadcrumbs: [] },
                                        { path: 'requirements', breadcrumbs: [] },
                                        { path: 'playbooks', breadcrumbs: [] },
                                        { path: 'attachments', breadcrumbs: [] },
                                    ],
                                },
                            ],
                        },
                        { path: 'apps', breadcrumbs: [] },
                        { path: 'subscription', breadcrumbs: [] },
                        { path: 'costs', breadcrumbs: [] },
                        { path: 'workflows', breadcrumbs: [] },
                    ],
                },
            ],
        },
        {
            path: 'platform-costs',
            breadcrumbs: [
                {
                    component: PlatformCostsCrumb,
                },
            ],
            children: [
                {
                    path: ':providerId',
                    breadcrumbs: [
                        {
                            component: PlatformCostProviderCrumb,
                            props: { param: 'providerId', isCurrentPage: true },
                        },
                    ],
                },
            ],
        },
        {
            path: 'skills',
            breadcrumbs: [
                {
                    component: StaticCrumb,
                    props: {
                        label: 'Skills',
                        href: '/admin/skills',
                    },
                },
            ],
            children: [
                {
                    path: ':skillId/versions/:versionId',
                    breadcrumbs: [
                        {
                            component: SkillCrumb,
                            props: { param: 'skillId' },
                        },
                        {
                            component: StaticCrumb,
                            props: { label: 'Version', isCurrentPage: true },
                        },
                    ],
                },
                {
                    path: ':skillId',
                    breadcrumbs: [
                        {
                            component: SkillCrumb,
                            props: { param: 'skillId' },
                        },
                    ],
                    children: [
                        {
                            path: 'file/:fileId',
                            breadcrumbs: [
                                {
                                    component: SkillFileCrumb,
                                    props: {
                                        skillParam: 'skillId',
                                        fileParam: 'fileId',
                                        isCurrentPage: true,
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        },
    ],
};
